import ItemTreeView from '../components/treeview/ItemTreeView.vue'
import PCIReportRepository from '@/shared/http/repositories/pci/pcireport'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import reportmodel from '@/shared/models/pci/reportmodel'
import { loading, toast } from '@/shared/utils/UIHelper'
import actionsForm from '@/shared/mixins/actionsForm'
import CompanyMixin from '@/store/module/company/mixin'
import itemMixim from '../mixins/itemMixim'
import reportForm from './report-form'

export default {
  name: 'Reports',
  mixins: [actionsForm, CompanyMixin, itemMixim],
  components: {
    ItemTreeView
  },
  data () {
    return {
      objList: [],
      objListFiltered: [],
      form: reportForm,
      data: reportmodel,
      item: {
        value: null,
        options: []
      },
      fixedItem: [
        { code: 10, text: 'IDENTIFICAÇÃO' },
        { code: 11, text: 'Detentora' },
        { code: 20, text: 'LOCALIZAÇÃO' },
        { code: 21, text: 'Cidade' },
        { code: 22, text: 'UF' },
        { code: 23, text: 'Tipo' },
        { code: 30, text: 'ACOMPANHAMENTO DE OBRA' },
        { code: 31, text: 'Prev. Início' },
        { code: 32, text: 'Início Real' },
        { code: 33, text: 'Prev. Término' },
        { code: 34, text: 'Término Real' },
        { code: 35, text: 'Prazo' },
        { code: 36, text: 'Dias Parados' },
        { code: 37, text: 'Prazo Real' },
        { code: 40, text: 'EQUIPE' },
        { code: 41, text: 'Coordenador' },
        { code: 42, text: 'Técnico' },
        { code: 43, text: 'Mestre de Obras' },
        { code: 50, text: 'ANÁLISE TÉCNICA' },
        { code: 51, text: 'Status' },
        { code: 52, text: 'Última Atualiz.' },
        { code: 60, text: 'AVALIAÇÃO' },
        { code: 61, text: 'Status' },
        { code: 62, text: 'Liberação' },
        { code: 63, text: 'Rejeição' },
        { code: 64, text: 'Autorização' },
        { code: 65, text: 'Conclusão' }
      ],
      reportTypeFilter: []
    }
  },
  methods: {
    onLoad () {
      this.form.tipo.options = [
        {label: this.$lang.PCI.Reports.Type0, code: 0},
        {label: this.$lang.PCI.Reports.Type1, code: 1},
        {label: this.$lang.PCI.Reports.Type2, code: 2}
      ]
      loading.push()
      PCIReportRepository.GetAll(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.objList = response.data.data
            this.objListFiltered = response.data.data
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())

      this.getList()
    },
    onChangeFilter (params, params2) {
      console.log(params)
      console.log(params2)
      console.log(this.reportTypeFilter)
      this.objListFiltered = this.objList.filter(o => !this.reportTypeFilter.length || this.reportTypeFilter.some(f => f === o.tipo))
    },
    getList () {
      loading.push()
      PCIRepository.GetPCIItems(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            const list = response.data.data.map(item => {
              return {
                id: item.id,
                name: item.descricao,
                parents: item.pais + ' > ' + item.descricao,
                value: item.codigo,
                parentId: item.itemPaiID,
                type: item.tipo,
                order: item.ordem,
                open: false,
                children: item.tipo === 1 ? [] : null
              }
            })

            this.item.options = this.getHierarchy(list)
          }
        })
        .finally(() => loading.close())
    },
    onCreate () {
      this.data.empresaID = this.company.id
      loading.push()
      PCIReportRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.onClear()
            this.onLoad()
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUpdate () {
      loading.push()
      PCIReportRepository.Update(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.onClear()
            this.onLoad()
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onDelete (obj) {
      loading.push()
      PCIReportRepository.Delete(obj.id)
        .then(response => {
          if (response.data.code > 0) {
            this.onClear()
            this.onLoad()
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onSelect (obj) {
      const setParents = (list, item) => {
        if (item.tipoItem === 1) {
          const fatherId = parseInt(item.itemFixo / 10) * 10
          const prefix = this.fixedItem.filter(fi => fi.code === fatherId)[0].text
          item.parents = prefix + ' > ' + this.fixedItem.filter(fi => fi.code === item.itemFixo)[0].text
        } else {
          list.forEach(it => {
            if (it.children) {
              setParents(it.children, item)
            } else {
              if (item.tipoItem === 0 && item.pciModeloItemID === it.id) {
                item.parents = it.parents
              }
            }
          })
        }
      }

      obj.itens.forEach(it => {
        setParents(this.item.options, it)
      })
      this.onEdit(obj)
    },
    onShowItems () {
      if (!this.form.itens.value) {
        this.form.itens.value = []
      }
      this.$refs.modalItems.show()
    },
    onSelectItem (item) {
      if (!item.children) {
        if (this.form.itens.value.some(it => it.pciModeloItemID === item.id)) {
          toast.warning('Item já selecionado!')
        } else {
          const reportItem = {
            id: '00000000-0000-0000-0000-000000000000',
            parents: item.parents,
            tipoItem: 0,
            pciModeloItemID: item.id,
            pciRelatorioID: this.data.id || '00000000-0000-0000-0000-000000000000',
            descricao: item.name
          }
          this.form.itens.value.push(reportItem)
          this.$refs.modalItems.hide()
        }
      }
    },
    onSelectFixedItem (item) {
      if (this.form.itens.value.some(it => it.itemFixo === item.code)) {
        toast.warning('Item já selecionado')
      } else {
        const fatherId = parseInt(item.code / 10) * 10
        const prefix = this.fixedItem.filter(fi => fi.code === fatherId)[0].text

        const reportItem = {
          id: '00000000-0000-0000-0000-000000000000',
          parents: prefix + ' > ' + this.fixedItem.filter(fi => fi.code === item.code)[0].text,
          tipoItem: 1,
          itemFixo: item.code,
          descricao: item.text
        }
        this.form.itens.value.push(reportItem)
        this.$refs.modalItems.hide()
      }
    },
    onRemoveItem (index) {
      this.form.itens.value.splice(index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/reports/reports.js